import { type OptionType } from '@hivebrite/design-system/Inputs';

/**
 * Converts TData values to OptionType format
 */
export const convertToOptions = <TData extends object>(
  value: Array<TData> | TData,
  toOptionsFn: (data: Array<TData>) => Array<OptionType>,
): Array<OptionType> | OptionType => {
  if (Array.isArray(value)) {
    return toOptionsFn(value);
  }

  return toOptionsFn([value])[0];
};
